import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import AdminLayout from '../Componets/AdminLayout';
import DataTable from 'react-data-table-component';
import { format } from 'date-fns';
import { FaUpload } from 'react-icons/fa6';
import * as XLSX from 'xlsx';
import { useRef } from 'react';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';

export default function AnswerSheetDetails() {
  const apiUrl = process.env.REACT_APP_API_URL; // Get the API URL from the .env file
  const [files, setFiles] = useState([]);
  const [barcodes, setBarcodes] = useState([]); // State to hold barcodes
  const [responseData, setResponseData] = useState([]); // State to hold response data for table
  const [searchTerm, setSearchTerm] = useState(''); // State to hold search term
  const [showDeleted, setShowDeleted] = useState(false); // State to track if the switch is on or off
  const location = useLocation();
  const { id, subjectId, subjectname, examname } = location.state || {}; // Get id and subjectId from location state
  const [history, setHistory] = useState([]);
  const [loaded, setLoaded] = useState(false); // Button loading effect
  const [folderName, setFolderName] = useState('');
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [fileName, setFileName] = useState('');
  const downloadRef = useRef(null);
  const folderInputRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(0); // State to store the total answer sheet count

  const navigate = useNavigate(); // Use navigate hook from react-router-dom

  // cheking if the user is logged in or not then redirecting to home page
  useEffect(() => {
    const role = localStorage.getItem('role');

    if (role !== 'ADMIN') {
      // Adjusted comparison to match the role stored in localStorage
      navigate('/');
    }
    // eslint-disable-next-line
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('token'); // Retrieve token from localStorage

      // Axios configuration for fetching path
      let fetchPathConfig = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${apiUrl}/api/answersheet/path/${id}/${subjectId}`,
        headers: {
          Authorization: `${token}`,
        },
      };

      // Fetch path
      const pathResponse = await axios.request(fetchPathConfig);
      const fetchedPath = pathResponse.data.path;
      // Data payload for saving path
      const data = {
        examId: id,
        subjectId: subjectId,
        answerSheetPath: fetchedPath,
      };

      // Axios configuration for saving path
      let savePathConfig = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apiUrl}/api/answersheet/path/save`,
        headers: {
          Authorization: `${token}`,
          'Content-Type': 'application/json',
        },
        data: data, // Include the data payload
      };

      // Save path and get barcode data
      const savePathResponse = await axios.request(savePathConfig);

      const barcodesData = savePathResponse.data.barcodesWithImageCounts;
      setCount(savePathResponse.data.count); // Set the total answer sheet count state
      if (Array.isArray(barcodesData)) {
        const collectedBarcodes = barcodesData.map((item) => item.barcode); // Collect all barcodes
        setBarcodes(collectedBarcodes); // Set barcodes state
        setResponseData(barcodesData); // Set response data for table
      } else {
        console.log('No barcodes found.');
      }
    } catch (error) {
      console.log(error);
      error.response?.status === 401 && navigate('/');

      // handleButtonClick();
    }
  };

  useEffect(() => {
    fetchData();
  }, [id, subjectId, apiUrl]); // Dependencies array

  // Define columns for DataTable
  const columns = [
    {
      name: 'No.',
      cell: (row, index) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span
            style={{
              width: '10px',
              height: '10px',
              borderRadius: '50%',
              backgroundColor: getStatusColor(row.status),
              marginRight: '8px',
            }}
          ></span>
          {(currentPage - 1) * rowsPerPage + index + 1}
        </div>
      ),
      width: '100px',
      center: 'true',
    },
    {
      name: 'Barcode',
      width: '100px',
      center: 'true',
      cell: (row) => (
        <div className="pt-2 fs-4 mb-2" id="table-btn ">
          <i className="bi bi-upc-scan"></i>
        </div>
      ),
    },
    {
      name: 'Barcode Number',
      selector: (row) => row.barcode,
      sortable: true,
      center: 'true',
    },
    {
      name: 'Block Numberr',
      selector: (row) => row.blockNumber,
      sortable: true,
      center: 'true',
    },

    {
      name: 'Number of Images',
      selector: (row) => row.noOfImages,
      sortable: true,
      center: 'true',
    },
    {
      name: 'Actions',
      width: '80px',
      center: 'true',
      cell: (row) => (
        <div>
          <button
            type="button"
            className="btn btn-outline-danger btn-sm mx-1"
            onClick={() => handleDelete(row)}
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Delete Answer Sheet"
          >
            <i className="bi bi-trash3-fill"></i>
          </button>
        </div>
      ),
    },
  ];

  const handleDelete = (row) => {
    if (window.confirm('Are you sure you want to delete this Answer Sheet?')) {
      const token = localStorage.getItem('token');
      axios
        .delete(
          `${apiUrl}/api/answersheet/remove-upload-student-answerSheet/${id}/${subjectId}/${row.barcode}`,
          {
            headers: {
              Authorization: `${token}`,
            },
          }
        )
        .then((res) => {
          toast.success(res.data.message);
          fetchData(); // Re-fetch data after deletion
        })
        .catch((err) => {
          err.response?.status === 401 && navigate('/');
          toast.error(err.response.data.message);
        });
    }
  };
  // Handle saving barcodes
  const handleSaveBarcode = async () => {
    // Show a confirmation dialog before proceeding
    const isConfirmed = window.confirm(
      'Are you sure you want to save the barcode details for this exam?'
    );

    if (!isConfirmed) {
      return; // Exit the function if the user cancels
    }
    try {
      const token = localStorage.getItem('token'); // Retrieve token from localStorage

      // Data payload
      const data = {
        examId: id,
        subjectId: subjectId,
        barcodeIds: barcodes, // Use the collected barcodes array
      };

      // Axios configuration
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${apiUrl}/api/answersheet/barcode/save`,
        headers: {
          Authorization: `${token}`,
        },
        data: data, // Include the data payload
      };

      // Axios request
      await axios.request(config);
      toast.success('Barcode details saved successfully');
      fetchData(); // Re-fetch data after saving
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
      error.response?.status === 401 && navigate('/');
    }
  };

  // Filter data based on search term
  const filteredData = responseData.filter(
    (item) =>
      item.barcode.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.noOfImages.toString().includes(searchTerm)
  );

  // Helper function to determine the color based on status
  const getStatusColor = (status) => {
    switch (status) {
      case 'Uploaded':
        return 'green';
      case 'NotUploaded':
        return 'red';
      case 'RecentlyUploaded':
        return 'orange';
      case 'Deleted':
        return 'gray';

      default:
        return 'purple'; // Default color if status is unknown
    }
  };

  // Toggle the switch and fetch deleted barcodes if needed
  const handleToggleSwitch = () => {
    setShowDeleted(!showDeleted);

    if (!showDeleted) {
      historyofBarcodes();
    } else {
    }
  };

  const historyofBarcodes = () => {
    const token = localStorage.getItem('token'); // Retrieve token from localStorage

    // Assuming 'id' and 'subjectId' are defined somewhere in your component
    let data = {
      examId: id, // Ensure 'id' is defined in your component scope
      subjectId: subjectId, // Ensure 'subjectId' is defined in your component scope
    };

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/answersheet/get-deleted-barcodes`,
      headers: {
        Authorization: `${token}`, // Use Bearer token if necessary
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        try {
          const { deletedBarcodes } = response.data; // Destructure response

          toast.success(' Deleted Barcode details');
          setHistory(deletedBarcodes);
        } catch (error) {
          console.error('Error processing response data:', error);
          toast.error(error.response.data.message);
          error.response?.status === 401 && navigate('/');
        }
      })
      .catch((error) => {
        console.error('Request failed:', error);
      });
  };

  const columns1 = [
    {
      name: 'No',
      cell: (row, index) => index + 1,
      width: '50px',
      center: 'true',
    },
    {
      name: 'Deleted Barcode',
      selector: (row) => row.barcode,
      sortable: true,
    },
    {
      name: 'Deleted Date',
      selector: (row) => formatDate(row.createdAt),
      sortable: true,
    },
    {
      name: 'Deleted Time',
      selector: (row) => formattime(row.createdAt),
      sortable: true,
    },
    {
      name: 'Deleted BY',
      selector: (row) => row.updatedByName,
      sortable: true,
    },
  ];
  const formatDate = (dateString) => {
    // Check if dateString is valid
    if (!dateString || isNaN(Date.parse(dateString))) {
      return 'Invalid Date'; // Return a default string if the date is invalid
    }

    const date = new Date(dateString);
    return format(date, 'dd/MM/yyyy');
  };

  const formattime = (dateString) => {
    // Check if dateString is valid
    if (!dateString || isNaN(Date.parse(dateString))) {
      return 'Invalid Time'; // Return a default string if the date is invalid
    }

    const date = new Date(dateString);
    return format(date, 'hh:mm a');
  };

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    if (selectedFiles.length === 0 && folderName !== 'answersheets') {
      toast.error('Please select a folder with files.');
      return;
    }
    setFiles(selectedFiles);

    if (selectedFiles.length > 0) {
      // Extract folder name from the first file's webkitRelativePath
      const fullPath = selectedFiles[0].webkitRelativePath;
      const folder = fullPath.split('/')[0]; // Get the folder name from the path
      setFolderName(folder); // Set folder name in the state
    }
  };

  const handleSubmit = async (event) => {
    setLoaded(true);
    event.preventDefault();

    const formData = new FormData();
    for (const file of files) {
      formData.append('files', file);
      formData.append('relativePaths[]', file.webkitRelativePath);
    }
    formData.append('examId', id);
    formData.append('subjectId', subjectId);

    const token = localStorage.getItem('token');

    try {
      const response = await axios.post(
        `${apiUrl}/api/answersheet/upload-student-answerSheet`,
        formData,
        {
          headers: {
            Authorization: ` ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      setLoaded(false);
      console.log(response.data);
      toast.success('Files uploaded successfully');
      fetchData();
      closemodel();
    } catch (error) {
      console.error('Error uploading files:', error);
      setLoaded(false);
      fetchData();
      setFiles([]);
      setFolderName('');
      if (folderInputRef.current) {
        folderInputRef.current.value = null; // Reset the folder input value
      }
      toast.error(
        `${error?.response?.data?.message}${
          error?.response?.data?.invalidBarcodes
            ? ` Invalid barcodes: ${error.response.data.invalidBarcodes.join(', ')}`
            : ''
        }${
          error?.response?.data?.insufficientFiles
            ? ` Insufficient files: ${error.response.data.insufficientFiles.join(', ')}`
            : ''
        }`
      );

      error.response?.status === 401 && navigate('/');
    }
  };

  const closemodel = () => {
    const closeButton = document.querySelector('#exampleModal .btn-close');
    if (closeButton) {
      closeButton.click();
      setFiles([]);
      setFolderName('');
      if (folderInputRef.current) {
        folderInputRef.current.value = null; // Reset the folder input value
      }
    }
  };

  const FileChange = (event) => {
    const fileInput = event.target;
    const file = fileInput.files[0];
    if (file) {
      setFile(file);
      setFileName(file.name);
      setMessage(`Selected file: ${file.name}`);
    } else {
      setFile(null);
      setFileName('');
      setMessage('');
    }
    // Reset the file input value to allow re-selecting the same file
    fileInput.value = '';
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage('Please select a file.');
      return;
    }
    setLoading(true);
    setMessage('');

    let data = new FormData();
    data.append('examId', id); // Example examId
    data.append('subjectId', subjectId); // Example subjectId
    data.append('blockNumber', file); // File to be uploaded
    const token = localStorage.getItem('token');

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/answersheet/Uplode-blockNumber`,
      headers: {
        Authorization: ` ${token}`, // Add "Bearer" before the token
        'Content-Type': 'multipart/form-data', // Set the content type for FormData
      },
      data: data,
    };

    try {
      const response = await axios.request(config);
      toast.success('Upload successful!');
      closemodelblock();
      fetchData();
    } catch (error) {
      toast.error(error.response.data.message);
      error.response?.status === 401 && navigate('/');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const closemodelblock = () => {
    const closeButton = document.querySelector('#uniqueModalId .btn-close');
    if (closeButton) {
      closeButton.click();
      setFile(null);
      setFileName('');
      setMessage('');
    }
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      filteredData.map((row, index) => ({
        barcode: row.barcode,
        blockNumber: row.blockNumber,
      }))
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
    XLSX.writeFile(workbook, `${examname} BlockNumber.xlsx`);
  };

  return (
    <main id="main" className="main">
      <AdminLayout ac4="active">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item ">
                {' '}
                <Link to="/AdminHome">Dashboard</Link>
              </li>
              <li
                className="breadcrumb-item  cursor-pointer"
                onClick={() => navigate('/ListExam')}
              >
                View Exam
              </li>
              <li
                className="breadcrumb-item cursor-pointer"
                onClick={() => navigate(-1)}
              >
                Exam subjects
              </li>
              <li className="breadcrumb-item active">
                AnswerSheetDetails {subjectname} ({count})
              </li>
            </ol>
          </nav>
        </div>

        <div className="row">
          <div className="container ">
            <div className="col-lg-16">
              {showDeleted ? ( // Conditional rendering based on switch state
                <div>
                  <div className="datatable-top">
                    <div className="datatable-search">
                      <input
                        className="form-control"
                        type="search"
                        placeholder="Search"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>

                    <div className="d-flex mb-0">
                      <button
                        type="button"
                        className="btn btn-primary btn-sm me-2"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content="Upload sheet"
                      >
                        <FaUpload />
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary btn-sm me-1"
                        data-bs-toggle="modal"
                        data-bs-target="#uniqueModalId"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content="Upload Block Number Sheet"
                      >
                        <i className="bi bi-file-arrow-up"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary btn-sm ms-1"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content="Refresh Data"
                        onClick={fetchData}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                    <div className="form-check form-switch text-end switch-div">
                      <input
                        className="form-check-input position-absolute switch"
                        type="checkbox"
                        id="flexSwitchCheckDefault"
                        checked={showDeleted} // Bind the switch state
                        onChange={handleToggleSwitch} // Toggle function
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckDefault"
                      >
                        Show Deleted
                      </label>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <DataTable
                      pagination
                      columns={columns1}
                      data={history}
                      className="custom-table"
                    />
                  </div>
                </div>
              ) : (
                <div>
                  <div className="datatable-top">
                    <div className="datatable-search">
                      <input
                        className="form-control"
                        type="search"
                        placeholder="Search"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                    <span style={{ marginLeft: '105px' }}>
                      <span style={{ color: 'green' }}>●</span> Uploaded |{' '}
                      <span style={{ color: 'red' }}>●</span> Not Uploaded |{' '}
                      <span style={{ color: 'orange' }}>●</span> Recently
                      Uploaded
                    </span>
                    <div className="d-flex mb-0">
                      <button
                        type="button"
                        className="btn btn-primary btn-sm me-2"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content="Upload sheet"
                      >
                        <FaUpload />
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary btn-sm me-1"
                        data-bs-toggle="modal"
                        data-bs-target="#uniqueModalId"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content="Upload Block Number Sheet"
                      >
                        <i className="bi bi-file-arrow-up"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary btn-sm ms-1"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content="Refresh Data"
                        onClick={fetchData}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                    <div className="form-check form-switch text-end switch-div">
                      <input
                        className="form-check-input position-absolute switch"
                        type="checkbox"
                        id="flexSwitchCheckDefault"
                        checked={showDeleted} // Bind the switch state
                        onChange={handleToggleSwitch} // Toggle function
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexSwitchCheckDefault"
                      >
                        Show Deleted
                      </label>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <DataTable
                      pagination
                      columns={columns}
                      data={filteredData}
                      className="custom-table"
                      paginationPerPage={rowsPerPage} // Set rows per page
                      paginationTotalRows={filteredData.length} // Total number of records
                      paginationDefaultPage={currentPage} // Default starting page
                      onChangePage={(page) => setCurrentPage(page)} // Update current page
                      onChangeRowsPerPage={(newPerPage) =>
                        setRowsPerPage(newPerPage)
                      } // Update rows per page
                    />

                    <div className="text-end mt-2">
                      <button
                        type="button"
                        className="btn btn-primary "
                        onClick={handleSaveBarcode}
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content="Save Barcode Sheet "
                      >
                        <i className="bi bi-folder-check"></i>
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <Tooltip id="my-tooltip" />
        <ToastContainer position="top-center" style={{ width: 'auto' }} />
      </AdminLayout>
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Upload Answersheets for ({examname})
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body text-center">
              <form
                id="uploadForm"
                onSubmit={handleSubmit}
                encType="multipart/form-data"
              >
                <div className="col">
                  <div
                    className="upload-area"
                    onClick={() => folderInputRef.current.click()}
                  >
                    <div className="icon">
                      <img
                        src="https://cdn-icons-png.freepik.com/512/16001/16001736.png"
                        alt="A cat"
                      />
                    </div>
                    <p className="text">Click to upload Answer sheet</p>
                    <input
                      type="file"
                      id="folderInput"
                      ref={folderInputRef}
                      webkitdirectory="true"
                      multiple
                      onChange={handleFileChange}
                      style={{ display: 'none' }}
                      accept="folder/*"
                    />
                    {folderName && <p className="folder-name">{folderName}</p>}
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="submit"
                form="uploadForm"
                className="btn btn-primary"
                disabled={loaded}
              >
                {loaded ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>{' '}
                    Uploading...
                  </>
                ) : (
                  <>Upload</>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="uniqueModalId"
        tabIndex="-1"
        aria-labelledby="uniqueModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="uniqueModalLabel">
                Upload Block List for ({examname})
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="col">
                <div
                  className="upload-area"
                  onClick={() => document.getElementById('formFile').click()}
                >
                  <div className="icon">
                    <img
                      src="https://cdn-icons-png.freepik.com/512/16001/16001736.png"
                      alt="A cat"
                    />
                  </div>
                  <p className="text">Click to upload Block List</p>
                  <input
                    type="file"
                    className="form-control"
                    id="formFile"
                    onChange={FileChange}
                    accept=".xlsx"
                    style={{ display: 'none' }}
                  />
                  {message && <p>{message}</p>}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  ref={downloadRef}
                  className="btn btn-primary  mx-2"
                  onClick={handleDownloadExcel}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content="Download Barcode Sheet"
                >
                  Example Sheet
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={closemodelblock}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={handleUpload}
                  disabled={loading}
                >
                  {loading ? 'Uploading...' : 'Upload'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
